"use client";

import React, { createContext, useState, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { BASE_URL } from "../config/apiConfig";

export const AdminProjectInsightsContext = createContext();

export const AdminProjectInsightsProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Get token
  const getToken = () => localStorage.getItem("token");


  // Fetch project insights
  const fetchProjectInsights = async () => {
    setLoading(true);
    setError("");

    try {
      const token = getToken();

      const res = await fetch(`${BASE_URL}/project-insights`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();

      if (data.status === true) {
        setProjects(data.projects || []);
        setSummary(data.summary || {});
      } else {
        setError(data.message || "Failed to fetch project insights");
        toast.error(data.message || "Failed to fetch project insights");
      }

    } catch (err) {
      console.error(err);
      setError("Error fetching project insights");
      toast.error("Error fetching project insights");

    } finally {
      setLoading(false);
    }
  };


  // Fetch on load
  useEffect(() => {
    const token = getToken();

    if (token) {
      fetchProjectInsights();
    }
  }, []);


  return (
    <AdminProjectInsightsContext.Provider
      value={{
        projects,
        summary,
        loading,
        error,
        fetchProjectInsights,
      }}
    >
      {children}
    </AdminProjectInsightsContext.Provider>
  );
};


export const useAdminProjectInsights = () =>
  useContext(AdminProjectInsightsContext);